import React, {FC, useEffect, useState} from 'react';
import { createPortal } from 'react-dom';

interface IModalPortal {
  children: React.ReactNode;
}


const ModalPortal: FC<IModalPortal> = ({children}) => {
  const modalRoot = document.getElementById( 'modal' );
  const [element] = useState(document.createElement( 'div' ));

  useEffect(()=>{
    if(modalRoot) {
      modalRoot.appendChild(element );
      document.body.classList.add("no-scroll")
    }

    return ()=> {
      if(modalRoot) {
        modalRoot.removeChild( element );
        document.body.classList.remove("no-scroll")
      }

    }
  }, [modalRoot, element])

  return createPortal( children, element );

}

export default ModalPortal;
